import React from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';

interface AssistantActionMenuProps {
  onSelectRecipe: () => void;
  onSelectSearch: () => void;
}

const AssistantActionMenu: React.FC<AssistantActionMenuProps> = ({
  onSelectRecipe,
  onSelectSearch,
}) => {
  const { t } = useTranslation();

  return (
    <List>
      <ListItemButton onClick={onSelectRecipe} sx={{ borderRadius: 1, mb: 0.5 }}>
        <ListItemIcon>
          <RestaurantMenuIcon color="primary" />
        </ListItemIcon>
        <ListItemText primary={t('aiAssistant.enterRecipe')} />
      </ListItemButton>
      <ListItemButton onClick={onSelectSearch} sx={{ borderRadius: 1 }}>
        <ListItemIcon>
          <SearchIcon color="primary" />
        </ListItemIcon>
        <ListItemText primary={t('aiAssistant.search')} />
      </ListItemButton>
    </List>
  );
};

export default AssistantActionMenu;
